import * as React from 'react';
import moment from 'moment-timezone';

import { PageHeader } from '../../components/core/PageHeader';
import { RulesDetailsList } from './RulesDetailsList';
import { RuleEdit } from './RuleEdit';
import { useState, useEffect, useCallback } from 'react';
import { PanelType, Panel } from '@fluentui/react';
import { onPageDidMount, onPageWillUnmount } from '../../redux/core';
import { useDispatch } from 'react-redux';
import { fetchRules } from '../../api/insurance';
import { Criterion, Rule } from '../../api/insurance.types';

export const Rules = () => {
  const [items, setItems] = useState<Rule[]>([]);
  const [openCreate, setOpenCreate] = useState(false);
  const [fetching, setFetching] = useState(false);
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(onPageDidMount('Rules'));
    return () => {
      dispatch(onPageWillUnmount('Rules'));
    };
  }, [dispatch]);

  const refresh = useCallback(() => {
    setFetching(true);
    fetchRules()
      .then((data) => setItems(data))
      .finally(() => setFetching(false));
  }, []);

  useEffect(() => {
    if (!openCreate) {
      // refresh on dialog close
      refresh();
    }
  }, [openCreate, refresh]);

  const actions = {
    items: [
      {
        key: 'Create rule ',
        name: 'Create rule',
        iconProps: { iconName: 'Add' },
        onClick: () => setOpenCreate(true),
      },
    ],
  };

  const createDialog = () => (
    <Panel isBlocking={true} isOpen={true} onDismiss={() => setOpenCreate(false)} type={PanelType.largeFixed} headerText={`Create rule`}>
      <RuleEdit
        onDone={() => setOpenCreate(false)}
        original={
          {
            criteria: [] as Criterion[],
            ruleParameters: {},
            active: true,
            beginDate: moment().startOf('day').utc().format(),
            endDate: moment().startOf('day').add(1, 'year').utc().format(),
          } as Rule
        }
      />
    </Panel>
  );

  return (
    <>
      <PageHeader title="Insurance Rules" actions={actions} isLoading={fetching} />
      <RulesDetailsList items={items} refresh={refresh} />
      {openCreate && createDialog()}
    </>
  );
};
